// @flow
export const HrSolutionsPageLocale = {
  header: [
    "HR SOLUTIONS",
    "İK ÇÖZÜMLERİMİZ"
  ],
  header_secondary: [
    "As ENV HR Consultancy, we provide periodical m/f employees throughout Turkey for field operations of our customers.",
    "ENV İK Danışmanlık olarak, Türkiye genelinde saha operasyonlarında dönemlik çalışabilen bay / bayan personel ağımızla hizmet vermekteyiz."
  ],
  content: {
    services: {
      description: [
        "Below you can find the fields in accordance with the specialities of our employees in which we will be happy to be of service:",
        "Bünyemiz çalışanlarının uzmanlıkları doğrultusunda sizlere hizmet vermekten mutluluk duyacağımız alanlar aşağıda listelenmiştir."
      ],
      items: {
        one: {
          content: [
            "Merchandising",
            "Merchandising"
          ],
          items: {
            one_one: [
              "Stok Taking and Reporting",
              "Stok Takibi ve Raporlama"
            ],
            one_two: [
              "Product Merchandising",
              "Ürünlerin Tanzim Teşhiri"
            ]
          }
        },
        two: {
          content: [
            "Marketing",
            "Pazarlama"
          ],
          items: {
            two_one: [
              "Promotion Activities",
              "Promosyon Aktiviteleri"
            ],
            two_two: [
              "Integrated Marketing",
              "Entegre Pazarlama"
            ]
          }
        },
        three: {
          content: [
            "Human Resources",
            "İnsan Kaynakları"
          ],
          items: {
            three_one: [
              "Copyright Management",
              "Özlük Hakları Yönetimi"
            ],
            three_two: [
              "Payroll Preparation",
              "Bordrolama Hizmeti"
            ]
          }
        },
        four: {
          content: [
            "Projects & Events",
            "Proje & Etkinlik"
          ],
          items: {
            four_one: [
              "Hosts & Hostesses",
              "Host-Hostes"
            ],
            four_two: [
              "Product Demo",
              "Ürün Demo"
            ]
          }
        },
        five: {
          content: [
            "Consultancy",
            "Danışmanlık"
          ],
          items: {
            five_one: [
              "Accounting",
              "Muhasebe Hizmeti"
            ],
            five_two: [
              "Legislation Consultancy",
              "Mevzuat Danışmanlığı"
            ]
          }
        }
      }
    },
    contact: [
      "You can contact iletisim@envanterium.com to get more information about our HR solutions.",
      "İK çözümlerimizle ilgili daha fazla bilgi almak için iletisim@envanterium.com adresi ile iletişime geçebilirsiniz."
    ]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicPages/HrSolutionsPage.locale.js